var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative px-4"},[_c('VueSlickCarousel',_vm._b({ref:"carousel",staticClass:"mx-2",attrs:{"arrows":true,"dots":true}},'VueSlickCarousel',_vm.settings,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }